enum ThemeRadii {
  Checkbox = 'checkbox',
}

export default ThemeRadii;
